import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';

import Tooltip from 'components/global/Tooltip';

import Status from './Status';
import * as S from './styled/SwitchInput.styled';

/**
 * @description switch input to allow user select on/off decision
 * @param {Object} props - props of the component.
 * @param {Boolean} [props.disabled=false] - disabled state of the input field.
 * @param {String} [props.name] - name of the input field.
 * @param {Boolean} [props.viewMode=false] - viewMode state of the input field.
 * @param {String} [props.className] - className of the input field.
 * @param {String} [props.style] - style of the input field.
 * @param {String} [props.value] - value of the global component.
 * @param {Function} [props.setValue] - setValue function for global component.
 * @returns {JSX} StringInput component.
 * @example
 * <SwicthInput
 * value={value}
 * setValue={setValue}
 * />
 */

const SwitchInput = (props) => {
	const { name = '', viewMode, style, className, disabledTooltip } = props;
	const innerRef = useRef(null);

	return (
		<>
			{viewMode ? (
				<ViewComponent {...props} />
			) : (
				<S.ToggleSwitch style={style} className={className}>
					<label ref={innerRef}>
						{name ? <FormComponent {...props} /> : <GlobalComponent {...props} />}
						<span className="slider" />
					</label>
				</S.ToggleSwitch>
			)}
			{disabledTooltip && <Tooltip componentRef={innerRef.current} title={disabledTooltip} placement="bottom" />}
		</>
	);
};

const ViewComponent = (props) => {
	const { name = '', value } = props;

	const formMethods = useFormContext();
	const viewValue = name ? formMethods?.getValues(name) : value;

	return (
		<Status
			value={typeof viewValue === 'boolean' ? viewValue.toString() : viewValue}
			style={{ padding: '1.2rem' }}
		/>
	);
};

const FormComponent = (props) => {
	const { disabled, name } = props;

	const formMethods = useFormContext();
	const register = formMethods?.register;

	return <input type="checkbox" disabled={disabled} {...register(name)} />;
};

const GlobalComponent = (props) => {
	const { disabled, value, setValue } = props;

	return <input type="checkbox" disabled={disabled} checked={value} onChange={setValue} />;
};

export default SwitchInput;
